import { Project } from 'src/modules/common/types/Project';
import { SyncMode } from 'src/modules/common/types/SyncMode';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const PROJECT_SYNC_RESET = createTrigger<void>('PROJECT_SYNC_RESET');
export const PROJECT_SYNC_PERFORM = createActions<SyncMode, Project, Project>('PROJECT_SYNC_PERFORM');
